// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".city-logo-img[data-v-00d7253f]{max-height:180px;width:auto}", ""]);
// Exports
module.exports = exports;
